import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import "./Radios.css";
export const Radios = ({
  items,
  name,
  label,
  value,
  onChange,
  direction = "row",
  outline = true,
  customRender,
  textAling = "flex-start",
  widthInfo = "auto",
  disabled,
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <FormControl disabled={disabled} className="radio-group-cont">
      {label && <FormLabel>{label}</FormLabel>}
      {!customRender ? (
        <RadioGroup
          name={name}
          value={value}
          onChange={handleChange}
          className={`radio-group-component ${outline ? "outlineStyle" : ""}`}
          style={{ flexDirection: direction }}
        >
          {items.map((item) => (
            <FormControlLabel
              key={item.value}
              value={item.value}
              control={<Radio />}
              label={
                item.icon ? (
                  <div className="icon-label">
                    <i className={`${item.icon}`}></i> <p>{item.label}</p>
                  </div>
                ) : (
                  item.label
                )
              }
              className={`${item.value === value ? "isActive" : ""}`}
              style={{
                justifyContent: textAling,
                width: widthInfo ? widthInfo : "auto",
              }}
            />
          ))}
        </RadioGroup>
      ) : (
        <div
          className={`radio-group-component ${outline ? "outlineStyle" : ""}`}
          style={{
            display: "flex",
            flexDirection: direction,
            gap: "0.5rem",
          }}
        >
          {items.map((item) => {
            const isChecked = item.value === value;
            return (
              <div
                key={item.value}
                className={`custom-render-radio ${isChecked ? "isActive" : ""}`}
                style={{ justifyContent: textAling, width: widthInfo }}
                onClick={() => onChange(item.value)}
              >
                <Radio
                  checked={isChecked}
                  value={item.value}
                  name={name}
                  onChange={(e) => onChange(e.target.value)}
                  onClick={(e) => e.stopPropagation()} 
                />
                {customRender(item, isChecked)}
              </div>
            );
          })}
        </div>
      )}
    </FormControl>
  );
};
